import { Box, TextField } from "@mui/material";

export type DateRange = [Date | null, Date | null];

type Props = {
  startText: string;
  endText: string;
  value?: DateRange;
  onChange?: (newValue: DateRange) => void;
};

function parseDate(dateString: string) {
  return dateString ? new Date(dateString) : null;
}

function dateToString(date: Date) {
  return date.toLocaleDateString("sv-SE");
}

const DateRangeInput: React.FC<Props> = ({ startText, endText, value, onChange }) => {
  return (
    <Box display="flex" gap={1}>
      <TextField
        label={startText}
        variant="filled"
        type="date"
        value={value?.[0] ? dateToString(value[0]) : ""}
        onChange={(e) => onChange?.([parseDate(e.target.value), value?.[1] ?? null])}
        slotProps={{
          inputLabel: { shrink: true },
        }}
      />
      <TextField
        label={endText}
        variant="filled"
        type="date"
        value={value?.[1] ? dateToString(value[1]) : ""}
        onChange={(e) => onChange?.([value?.[0] ?? null, parseDate(e.target.value)])}
        slotProps={{
          inputLabel: { shrink: true },
        }}
      />
    </Box>
  );
};

export default DateRangeInput;
